import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const AI = ({
  svgProps = defaultProps.svgProps,
  pathProps = defaultProps.pathProps,
}: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };
  return (
    <svg {...mergedSvgProps}>
      <path
        d="M21 12C21 11.8218 20.5927 11.6545 19.8744 11.509C16.1554 10.7543 13.2476 7.84462 12.4911 4.12568C12.3456 3.40917 12.1783 3 12 3C11.8218 3 11.6545 3.40736 11.509 4.12568C10.7543 7.84462 7.84466 10.7525 4.12573 11.509C3.40922 11.6545 3.00004 11.8218 3.00004 12C3.00004 12.1782 3.4074 12.3455 4.12573 12.491C7.84466 13.2457 10.7525 16.1554 11.509 19.8743C11.6545 20.5908 11.8218 21 12 21C12.1783 21 12.3456 20.5926 12.4911 19.8743C13.2457 16.1554 16.1554 13.2475 19.8744 12.491C20.5909 12.3455 21 12.1782 21 12Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default AI;
